import Riper from '@/app';

import Auth from './auth';
import Redemption from './redemption';

const WooCommerceRadix = {
  Auth,
  Redemption,
  init() {
    const pages = window.beans_init_data.pages;
    const args = {
      currentPage: pages._current,
      onLogin: () => (window.location = pages.login),
      onAbout: () => (window.location = pages.liana),
      onAboutBamboo: () => (window.location = pages.bamboo),
      onViewCart: () => (window.location = pages.cart),
      onRegister: Auth.onRegister,
      Auth,
      Redemption,
    };
    return Riper.init(args);
  },
};

export default WooCommerceRadix;
